angular.module('app.services').service('areasService', function ($rootScope, api, areas, UserService) {
    const Service = this;

    Service._model = api('areas');
    Service._areas = areas;

    Service.getAll = () => Service._areas;

    Service.selectize = () =>
        Service._model
            .selectize({
                transform: {
                    id: 'id',
                    value: 'value',
                },
            })
            .then((response) => _.sortBy(response.data, 'label'));

    Service.find = (id) => {
        const idAsInt = parseInt(id);
        const area = _.find(Service._areas, { id: idAsInt });

        if (!area) {
            return Service._model.get(idAsInt).then((response) => {
                Service._areas.push(response);
                return response;
            });
        }

        return area;
    };

    Service.save = (area) => {
        const promise = Service._model.save(area.id, area);

        promise.then(() => {
            Service._model.clearCache();
        });

        return promise;
    };

    Service.changeArea = (newAreaId, changeOnServer) => {
        const defaultArea = 1;

        const areaId = (newAreaId || $rootScope.userAreaId || defaultArea).toString();

        const locally = () => {
            $rootScope.$session.area = _.find(Service._areas, (area) => area.id.toString() === areaId);
        };

        if (changeOnServer) {
            return Service._model
                .post(
                    {
                        area_id: areaId,
                    },
                    {
                        pathSuffix: '/change',
                    }
                )
                .then((userData) => {
                    UserService.refreshData({ data: userData });
                    locally();
                });
        } else {
            locally();
        }
    };

    Service.current = () => ($rootScope.$session.area ? $rootScope.$session.area : { id: 1 });

    Service.currentId = () => ($rootScope.$session.area && $rootScope.$session.area && $rootScope.$session.area.id ? $rootScope.$session.area.id.toString() : 1);
});
